var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.082,
    height: 46.011,
    viewBox: "0 0 46.082 46.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(5.909 5.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3490",
    "data-name": "Trazado 3490",
    d: "M144.991,164.429a2.22,2.22,0,0,1-1.553-2.1V155.01a2.969,2.969,0,0,0-1.36-2.489,3.062,3.062,0,0,0-2.634-.352l-2.943.957a.673.673,0,0,0,0,1.277,2.22,2.22,0,0,1,1.553,2.1v7.319a2.969,2.969,0,0,0,1.36,2.489,3.053,3.053,0,0,0,2.634.352l2.943-.959a.673.673,0,0,0,0-1.279Zm-3.359.959a1.724,1.724,0,0,1-1.481-.2,1.633,1.633,0,0,1-.75-1.364v-7.319a3.522,3.522,0,0,0-1.1-2.552l1.556-.508a1.72,1.72,0,0,1,1.48.2,1.632,1.632,0,0,1,.75,1.364v7.321a3.523,3.523,0,0,0,1.1,2.553Zm0,0",
    transform: "translate(-123.701 -138.319)",
    fill: "#0058f4",
    stroke: "#0058f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3491",
    "data-name": "Trazado 3491",
    d: "M155.384,62.739a3.364,3.364,0,1,0-3.364-3.364,3.364,3.364,0,0,0,3.364,3.364Zm0-5.382a2.019,2.019,0,1,1-2.019,2.019,2.019,2.019,0,0,1,2.019-2.019Zm0,0",
    transform: "translate(-138.337 -50.386)",
    fill: "#0058f4",
    stroke: "#0058f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3492",
    "data-name": "Trazado 3492",
    d: "M16.15,0A16.146,16.146,0,1,0,22.6,30.945h9.022A.673.673,0,0,0,32.1,29.8l-3.447-3.447A16.14,16.14,0,0,0,16.15,0ZM27.265,26.866,30,29.6H22.459a.681.681,0,0,0-.274.059,14.817,14.817,0,1,1,5.049-3.712.673.673,0,0,0,.029.921Zm0,0",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, -5.207, 11.928)",
    fill: "#0058f4",
    stroke: "#0058f3",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4b270faec7f0dc852a135fa870d6af35.svg";
export { ForwardRef as ReactComponent };